export default {
  orgAdmin: 'Org Administrator',
};
